(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var radios = document.querySelectorAll('input[name="attributes[USt.-Auswahl]"]');
  var checkoutBtn = document.getElementById('checkout');
  var dynBtns = document.getElementById('dynamic-checkout-cart');
  var hint = document.getElementById('ust-hint');
    var quoteBtn = document.querySelector(
    '[data-pv-quote-open]'
  );

  function setUiEnabled(ok) {
    if (checkoutBtn) {
      checkoutBtn.disabled = !ok;
      checkoutBtn.style.pointerEvents = ok ? '' : 'none';
      checkoutBtn.style.opacity = ok ? '1' : '0.5';
    }

    if (dynBtns) {
      dynBtns.style.pointerEvents = ok ? '' : 'none';
      dynBtns.style.opacity = ok ? '1' : '0.5';
    }

    if (quoteBtn) {
      quoteBtn.disabled = !ok;
      quoteBtn.style.pointerEvents = ok ? '' : 'none';
      quoteBtn.style.opacity = ok ? '1' : '0.5';
    }
  }

  function validate() {
    var val = document.querySelector('input[name="attributes[USt.-Auswahl]"]:checked');
    if (!val) {
      setUiEnabled(false);
      if (hint) hint.style.display = 'none';
      return;
    }

    // Egal welche Auswahl → Checkout aktiv
    setUiEnabled(true);
  }

if (radios.length) {
  validate();
}
});

  } catch(e) { console.error(e); }
})();
})();
